import { ReactNode } from 'react';
import styles from './AppContent.module.scss';

const AppContent = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <div className={`${styles.content} ${className}`}>{children}</div>
);

export { AppContent };
